import Vue from 'vue';

export default {
  SET_TICKET_LIST: (state, payload) => {
    Vue.set(state, 'ticketList', payload);
  },
  SET_HEADERS_SETTINGS: (state, payload) => {
    Vue.set(state, 'headersSettings', payload);
  },
  SET_SEVEN_TAXES: (state, data) => {
    Vue.set(state, 'sevenTaxes', data);
  },
};
